<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm03">
<div class="chapterHead">
<h2 class="chapterTitle2" style="text-indent: 0%;"><span class="bold">Hungry Girl Staples</span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent:0%;">You’ll find these specific products popping up in many of our recipes:</p>
<div class="unOrderedList">
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Fiber One bran cereal (original)</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Splenda No Calorie Sweetener (granulated)</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Boca Original Meatless Burgers</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Bisquick Heart Smart baking mix</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Pillsbury Reduced Fat Crescent Rolls</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">The Laughing Cow Light Original Swiss cheese</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">La Tortilla Factory Smart &amp; Delicious Low Carb/High Fiber Tortillas</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">House Foods Tofu Shirataki, Fettuccine, and Spaghetti Shaped Noodle Substitute</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Cool Whip Free</span></p>
</div>
<p class="paraCenter" style="text-indent:0%;"><img alt="image" src="Images/21a.jpg"/></p>
<div class="unOrderedList">
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Fat Free Reddi-wip</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">I Can’t Believe It’s Not Butter! Spray</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Coffee-mate Sugar Free French Vanilla powdered creamer</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Hellmann’s/Best Foods Dijonnaise</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Frank’s RedHot Original Cayenne Pepper Sauce</span></p>
<p class="listItem1" style="text-indent: -4%;"><img alt="image" src="Images/star.jpg"/> <span class="bold">Jell-O Sugar Free Pudding Snacks, assorted flavors</span></p>
</div>
<p class="paraCenter" style="text-indent:0%;"><img alt="image" src="Images/21b.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312556174_fm03.vue?c7e4059a